import { motion } from "framer-motion";
import { CONVERSATION } from "../../data/content";

export default function Act2Conversation() {
  return (
    <section data-testid="act-conversation" className="relative bg-[#030303] py-20 md:py-28 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="md:pl-[6%] max-w-3xl">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="block font-display text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-10"
          >
            Seamos honestos
          </motion.span>

          <div className="space-y-6 md:space-y-7">
            {CONVERSATION.map((line, i) => {
              const last = i >= CONVERSATION.length - 2;
              return (
                <motion.p
                  key={i}
                  initial={{ opacity: 0, y: 28 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-70px" }}
                  transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                  className={`font-serif leading-[1.12] tracking-tight text-3xl sm:text-4xl md:text-5xl text-balance ${
                    last ? "text-white" : "text-white/55"
                  }`}
                >
                  {line}
                </motion.p>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
